var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg9797550691600459969(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F77B55",
    d: "M27.8 372.8l-2.4-2 108.9-127.7 94.9 107.3 107.5-202.7 66 62.8 86.3-78.6 2.1 2.4-88.4 80.5-65.1-62-107.8 203-95.5-108z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#92E0EA",
    d: "M278.1 425.3c-14.9 4.2-30.5 6.4-46.7 6.4-95.7 0-173.3-77.6-173.3-173.3 0-95.7 77.6-173.3 173.3-173.3 68.8 0 128.3 40.1 156.2 98.2l21.3-11.8C376.8 106 309.4 60.8 231.4 60.8c-109.2 0-197.6 88.5-197.6 197.6 0 109.2 88.5 197.6 197.6 197.6 17.9 0 35.2-2.4 51.6-6.9l-4.9-23.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#92E0EA",
    d: "M435.6 259.1l-8.2-117.7-77.6 36.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#353F49",
    d: "M234.7 277.5l-79.3-45.8 7.3-12.7 72 41.5 104-59.7 7.3 12.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F77B55",
    d: "M258.2 264.6c0 11.8-9.6 21.4-21.4 21.4-11.8 0-21.4-9.6-21.4-21.4 0-11.8 9.6-21.4 21.4-21.4 11.8 0 21.4 9.6 21.4 21.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CDCCCA",
    d: "M241.1 111.5c-2.4 2.4-6.2 2.4-8.6 0-2.4-2.4-2.4-6.2 0-8.6 2.4-2.4 6.2-2.4 8.6 0 2.3 2.4 2.3 6.2 0 8.6zM165.5 129.5c-.9 3.3-4.2 5.2-7.5 4.3-3.3-.9-5.2-4.2-4.3-7.5.9-3.3 4.2-5.2 7.5-4.3 3.3.8 5.2 4.2 4.3 7.5zM109 182.8c.9 3.3-1.1 6.6-4.3 7.5-3.3.9-6.6-1.1-7.5-4.3-.9-3.3 1.1-6.6 4.3-7.5 3.3-.9 6.7 1 7.5 4.3zM86.8 257.2c2.4 2.4 2.4 6.2 0 8.6-2.4 2.4-6.2 2.4-8.6 0-2.4-2.4-2.4-6.2 0-8.6 2.4-2.4 6.2-2.4 8.6 0zM104.7 332.7c3.3.9 5.2 4.2 4.3 7.5-.9 3.3-4.2 5.2-7.5 4.3-3.3-.9-5.2-4.2-4.3-7.5.9-3.2 4.3-5.2 7.5-4.3zM158 389.2c3.3-.9 6.6 1.1 7.5 4.3.9 3.2-1.1 6.6-4.3 7.5-3.3.9-6.6-1.1-7.5-4.3-.8-3.3 1.1-6.6 4.3-7.5zM232.4 411.4c2.4-2.4 6.2-2.4 8.6 0 2.4 2.4 2.4 6.2 0 8.6-2.4 2.4-6.2 2.4-8.6 0-2.3-2.3-2.3-6.2 0-8.6zM308 393.5c.9-3.3 4.2-5.2 7.5-4.3 3.3.9 5.2 4.2 4.3 7.5-.9 3.2-4.2 5.2-7.5 4.3-3.2-.9-5.2-4.3-4.3-7.5zM364.5 340.2c-.9-3.3 1.1-6.6 4.3-7.5 3.3-.9 6.6 1.1 7.5 4.3.9 3.3-1.1 6.6-4.3 7.5-3.3.9-6.7-1.1-7.5-4.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#CDCCCA",
    cx: 391,
    cy: 261.5,
    r: 6.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#CDCCCA",
    d: "M315.5 133.8c-3.3.9-6.6-1.1-7.5-4.3-.9-3.3 1.1-6.6 4.3-7.5 3.3-.9 6.6 1.1 7.5 4.3.8 3.2-1.1 6.6-4.3 7.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F77B55",
    d: "M35.2 377.7c0 5.8-4.7 10.5-10.5 10.5s-10.5-4.7-10.5-10.5 4.7-10.5 10.5-10.5c5.8-.1 10.5 4.7 10.5 10.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F77B55",
    d: "M144 247.8c0 5.8-4.7 10.5-10.5 10.5s-10.5-4.7-10.5-10.5 4.7-10.5 10.5-10.5S144 242 144 247.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F77B55",
    d: "M239.2 355.4c0 5.8-4.7 10.5-10.5 10.5s-10.5-4.7-10.5-10.5 4.7-10.5 10.5-10.5 10.5 4.7 10.5 10.5z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F77B55",
    d: "M345.3 154.2c0 5.8-4.7 10.5-10.5 10.5s-10.5-4.7-10.5-10.5 4.7-10.5 10.5-10.5c5.8-.1 10.5 4.6 10.5 10.5z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F77B55",
    d: "M497.5 134.7c0 5.8-4.7 10.5-10.5 10.5s-10.5-4.7-10.5-10.5 4.7-10.5 10.5-10.5c5.7-.1 10.5 4.6 10.5 10.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9797550691600459969);
export default __webpack_public_path__ + "static/media/9797550691600459969.607bbf0345e5083e01d990401ac2cc76.svg";
export { ForwardRef as ReactComponent };